export default "__VITE_ASSET__DQK83vtV__"